function updateBtn(btnID,varID) {
    const button = document.querySelector(btnID)
    const parent = button.closest("li")
    if (!button) return;
    const buttonData = button.dataset
    for (const [key, value] of Object.entries(buttonData)) {
        if (key == varID) {
            if (value == "null") {
                parent.classList.add("hidden");
            } else {
                button.href = value
                parent.classList.remove("hidden");
            }
            return;
        }
    };
}

FoxTheme?.pubsub?.subscribe("variant-change", ({ data }) => {
  const variant = data?.variant;
  updateBtn('#btn_sample',variant.id);
  updateBtn('#btn_datasheet',variant.id);
});